// src/components/Dashboard/Filters.js
import React from 'react';
import {
  Typography,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Button,
  Box
} from '@mui/material';

export default function Filters({
  filterTipo,
  setFilterTipo,
  search,
  setSearch,
  onClear,
  isAdmin
}) {
  // 🔒 Si no es admin, no renderizamos nada
  if (!isAdmin) return null;

  return (
    <>
      <Divider sx={{ my: 3 }} />
      <Typography variant="h6">📂 Filtrar envíos</Typography>

      <FormControl fullWidth margin="normal">
        <InputLabel>Filtrar por tipo</InputLabel>
        <Select
          value={filterTipo}
          label="Filtrar por tipo"
          onChange={(e) => setFilterTipo(e.target.value)}
        >
          <MenuItem value="">Todos</MenuItem>
          <MenuItem value="Marítimo">Marítimo</MenuItem>
          <MenuItem value="Aéreo">Aéreo</MenuItem>
          <MenuItem value="Terrestre">Terrestre</MenuItem>
        </Select>
      </FormControl>

      <TextField
        label="Buscar por número de guía"
        fullWidth
        margin="normal"
        placeholder="Ejemplo: ABC123"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      <Box sx={{ mt: 2 }}>
        <Button
          variant="outlined"
          color="secondary"
          onClick={onClear}
          disabled={!filterTipo && !search}
        >
          Limpiar filtros
        </Button>
      </Box>
    </>
  );
}